import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';
import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type {
	RadioButtonsPublicGetValue,
	RadioButtonsPublicSetValue,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/radio-buttons.tsx';
import { applyOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/apply-options-visibility-rule/index.tsx';
import { getAvailableOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-available-options-visibility-rule/index.tsx';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/single-value-lookup/index.tsx';

export type RadioButtonsInternalAllowedValue = {
	id: string;
	value: string;
};

export type RadioButtonsInternalValue = {
	label: string;
	value: string;
} | null;

export const transformRadioButtonsSetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: RadioButtonsInternalAllowedValue[],
): RadioButtonsInternalAllowedValue[] =>
	applyOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const transformRadioButtonsGetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: RadioButtonsInternalAllowedValue[],
): OptionsVisibility => getAvailableOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const radioButtonsSetValueTransformer = (
	value: RadioButtonsPublicSetValue,
	allowedValues?: RadioButtonsInternalAllowedValue[],
): RadioButtonsInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<RadioButtonsInternalAllowedValue>(
		value,
		allowedValues,
		'id',
	);

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return { value: foundValue.id, label: foundValue.value };
};

export const radioButtonsGetValueTransformer = (
	value: RadioButtonsInternalValue,
): RadioButtonsPublicGetValue => {
	if (!value) {
		return null;
	}

	const { label, value: id } = value;

	return { id, value: label };
};
